import style from "./style.scss";

const VoteItems = ({ items }) => {
  return (
    <ul class={style.voteItems}>
      {items.map((item, index) => (
        <li key={index} class={item.selected ? style.selected : ""}>
          {item.text}
        </li>
      ))}
    </ul>
  );
};

export default VoteItems;
